import request from '@/router/axios';

const getList = (current, size, params) => request({
  url: '/api/mcc-staff/processfield/page',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})

const getMyList = (current, size, params) => request({
  url: '/api/mcc-staff/processfield/mySend',
  // url: '/api/mcc-staff/processfield/personalProcess',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})

const add = (params, router) => request({
  url: '/api/mcc-staff/processfield/save',
  method: 'post',
  headers: {
    router,
  },
  data: params,
})

const saveAndStart = (params, router) => request({
  url: '/api/mcc-staff/processfield/startProcess',
  method: 'post',
  headers: {
    router,
  },
  data: params,
})

const start = params => request({
  url: '/api/mcc-staff/processfield/startEmploymentProcess',
  method: 'post',
  params: { ...params },
})

const detail = params => request({
  url: '/api/mcc-staff/processfield/detail',
  method: 'get',
  params: {
    ...params,
  },
})

const edit = params => request({
  url: '/api/mcc-staff/processfield/update',
  method: 'post',
  data: params,
})

const remove = id => request({
  url: '/api/mcc-staff/processfield/remove',
  method: 'post',
  params: {
    id,
  },
})
const removeNew = id => request({
  url: '/api/mcc-staff/processfield/remove2',
  method: 'post',
  params: {
    id,
  },
})
const history = params => request({
  url: '/api/mcc-base/base-flow-task/history-list',
  method: 'get',
  params: {
    ...params,
  },
})

const resourceView = params => request({
  url: '/api/blade-flow/process/resource-view',
  method: 'get',
  responseType: 'image/*',
  params: {
    ...params,
  },
})

export const getProcesskeys = params => request({
  url: '/api/mcc-base/base/templateForm/queryTemplateFormProcess',
  method: 'get',
  params: {
    ...params,
  },
})

export const getAllProcess = (current, size, params) => request({
  url: '/api/mcc-base/base/templateForm/list',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})

const getMyApplicationByStaff = (current, size, params) => request({
  url: '/api/mcc-staff/processfield/approverProcess',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})
const pageConfirmationAssessment = (current, size, params) => request({
  url: '/api/mcc-staff/positiverecord/pageConfirmationAssessment',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})
const pageConfirmationAssessmentDetail = params => request({
  url: '/api/mcc-staff/positiverecord/detail',
  method: 'get',
  params: {
    ...params,
  },
})
// 自己过手的流程接口
// /api/mcc-worker/processfield/approverProcess
// 工人流程
const getWorkerList = (current, size, params) => request({
  url: '/api/mcc-worker/processfield/page',
  // url: '/api/mcc-worker/processfield/approverProcess',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})
// 自己发起的流程接口
// 只获取自己的申请列表
const getWorkerSelfList = (current, size, params) => request({
  url: '/api/mcc-worker/processfield/personalProcess',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})

const workerDetail = params => request({
  url: '/api/mcc-worker/processfield/detail',
  method: 'get',
  params: {
    ...params,
  },
})

// 发送
const workerSeed = (params, headers) => request({
  url: '/api/mcc-worker/processfield/startEmploymentProcess',
  method: 'post',
  headers: {
    // router,
    headers,
  },
  // data: params,
  params,
})

// 工人无草稿发起流程
const workerAdd = (params, headers) => request({
  url: '/api/mcc-worker/processfield/startProcess',
  method: 'post',
  headers: {
    // router,
    ...headers,
  },
  data: params,
})

const workerSaveAndStart = (params, router, headers) => request({
  url: '/api/mcc-worker/processfield/save',
  method: 'post',
  headers: {
    // router,
    // headers,
  },
  data: params,
  // params,
})

const exportProcess = params => request({
  url: '/api/mcc-staff/processfield/exportProcess',
  method: 'get',
  responseType: 'blob',
  params: {
    ...params,
  },
})

const cancelProcess = params => request({
  url: '/api/mcc-base/base-flow-task/cancelProcess',
  method: 'post',
  params: {
    ...params,
  },
})

const hrAudited = params => request({
  url: '/api/mcc-staff/processfield/hrAudited',
  method: 'post',
  params: {
    ...params,
  },
})
const processfieldecall = params => request({
  url: '/api/mcc-staff/processfield/recall',
  method: 'post',
  data: {
    ...params,
  },
})

const checkOt = params => request({
  url: '/api/mcc-staff/process/ot/check',
  method: 'get',
  params: params,
})

export default {
  getList,
  add,
  detail,
  edit,
  remove,
  start,
  history,
  resourceView,
  saveAndStart,
  getWorkerList,
  workerDetail,
  getProcesskeys,
  workerSaveAndStart,
  workerAdd,
  workerSeed,
  getWorkerSelfList,
  getMyList,
  getMyApplicationByStaff,
  exportProcess,
  cancelProcess,
  hrAudited,
  pageConfirmationAssessment,
  pageConfirmationAssessmentDetail,
  processfieldecall,
  removeNew,
  checkOt,
};
